// extracted by mini-css-extract-plugin
export var active = "_s0-1";
export var circle = "_s0-0";
export var completed = "_s0-2";
export var connector = "_s0-4";
export var connectorCompleted = "_s0-7";
export var connectorSpacer = "_s0-5";
export var iconStrokeOverride = "_s0-8";
export var labelContainer = "_s0-6";
export var pending = "_s0-3";